import { HStack } from '../bases/HStack'
import Image from 'next/image'
import Star from '@/public/images/star.png'
import StarEmpty from '@/public/images/star_empty.png'

export const StarArea = (props: { parentKey: string; rarity: number }) => {
  const { parentKey, rarity } = props
  return rarity > 0 ? (
    <HStack className="gap-x-0.5">
      {[...Array(5)].map((_, i) => (
        <Image
          key={`${parentKey}_star_${i}`}
          src={rarity > i ? Star : StarEmpty}
          width={12}
          height={12}
          alt=""
        />
      ))}
    </HStack>
  ) : (
    <></>
  )
}
